export const OPEN = "sidebar/OPEN";
export const SHOW = "sidebar/SHOW";
export const HIDE = "sidebar/HIDE";
export const UPDATE = "sidebar/UPDATE";
export const CLEAR = "sidebar/CLEAR";
export const CLOSE = "sidebar/CLOSE";
